<template>
    <span :class="['overdot',myclass]" :title="needtitle?gettitle():''" v-html="gettitle()"></span>
</template>

<script>
    export default {
        name: 'ffoverdot',
        props: {
            title: {
                type: String,
                default: ''
            },
            title_en: {
                type: String,
                default: ''
            },
            myclass: {
                type: String,
                default: ''
            },
            needtitle: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            gettitle: function () {
                return this.title_en ? this.$common.langinfo(this.title, this.title_en) : this.title;
            }
        }
    }
</script>
